import { IFeature, IFeatureFile } from 'api/models';

export const getFeatureGuideline = (feature: IFeature) =>
    feature.hasGuideline !== false && feature.guideline && typeof feature.guideline === 'object'
        ? feature.guideline
        : null;

export const hasFeatureGuideline = (feature: IFeature) => feature.hasGuideline === true;

export const getFeatureDetailsUrl = (feature: IFeature) =>
    `/whats-new/features/${encodeURIComponent(feature._id)}/guide`;

export const getFeatureCoverFile = (feature: IFeature): IFeatureFile | undefined =>
    feature.files?.find((file) => file.isCover) ?? feature.files?.[0];

export const getSafeInteractiveUrl = (value?: string): string | null => {
    if (!value) return null;

    try {
        const url = new URL(value);
        return url.protocol === 'http:' || url.protocol === 'https:' ? url.toString() : null;
    } catch {
        return null;
    }
};

export const getFeatureTypeLabel = (type: IFeature['type']) => `${type.charAt(0)}${type.slice(1).toLowerCase()}`;

export const sortFeaturesByDate = (features: IFeature[]) =>
    [...features].sort((first, second) => new Date(second.date).getTime() - new Date(first.date).getTime());
